"use strict";
const allCustomerSubUnitRoles = [
    'customerSubUnit',
    'customerSubUnitAdmin',
    'customerSubUnitPurchaserManager',
    'customerSubUnitEconomy',
    'customerSubUnitPurchaser',
];
module.exports = { allCustomerSubUnitRoles };
